<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // STYLING
    import 'tailwindcss/tailwind.css';

    // CASSIOPEIA
    import {
        ADDRESS_STORE,
        AddressForm,
        Heading,
        SESSION_ORGANIZATION,
        openModal,
    } from '@smatch/cassiopeia-web-components';

    // TYPES
    import type { Address } from 'src/app/types';

    /* INITIALIZE ------------------------------------------------------------------------------ */

    $: organizationKey = $SESSION_ORGANIZATION?._.key;

    const getAddress = (): Partial<Address> => {
        // eslint-disable-next-line @typescript-eslint/naming-convention, no-unused-vars
        const { _, ...ADDRESS } = Object.values($ADDRESS_STORE).find(address => address.type === 'main') ?? {};

        if (Object.keys(ADDRESS).length === 0) {
            return { organizationKey, type: 'inbound' };
        }
        return { ...ADDRESS, organizationKey, type: 'inbound' };
    };

    const ADDRESS: Partial<Address> = getAddress();

</script>

{#if organizationKey !== undefined}
    <Heading size = 'md'>Delivery Address</Heading>
    <AddressForm
        action = { '_' in ADDRESS ? 'update' : 'create' }
        address = { ADDRESS }
        on:cancel = { openModal.bind(null, '#onboarding') }
        on:save = { openModal.bind(null, '#onboarding') }
        showCancel
        { organizationKey }
    />
{/if}